export default __webpack_public_path__ + "static/viinitie-banner-wedding-desktop-wide.976ffaf9b58c704ffb5ac2c29244adb4.jpg";